import * as Types from '../../../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ViewBucketDataVariables = Types.Exact<{
  input: Types.ViewBucketDataInput;
}>;

export type ViewBucketData = {
  viewBucketData: {
    data: Array<Pick<Types.HoldingTankRawEvent, 's3Key' | 'event' | 'error'>>;
    pageInfo: Pick<Types.PageInfo, 'hasNextPage' | 'paginationToken'>;
  };
};

export const ViewBucketDataDocument = gql`
  query ViewBucketData($input: ViewBucketDataInput!) {
    viewBucketData(input: $input) {
      data {
        s3Key
        event
        error
      }
      pageInfo {
        hasNextPage
        paginationToken
      }
    }
  }
`;

/**
 * __useViewBucketData__
 *
 * To run a query within a React component, call `useViewBucketData` and pass it any options that fit your needs.
 * When your component renders, `useViewBucketData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewBucketData({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useViewBucketData(
  baseOptions: Apollo.QueryHookOptions<ViewBucketData, ViewBucketDataVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ViewBucketData, ViewBucketDataVariables>(ViewBucketDataDocument, options);
}
export function useViewBucketDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ViewBucketData, ViewBucketDataVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ViewBucketData, ViewBucketDataVariables>(
    ViewBucketDataDocument,
    options,
  );
}
export function useViewBucketDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ViewBucketData, ViewBucketDataVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ViewBucketData, ViewBucketDataVariables>(
    ViewBucketDataDocument,
    options,
  );
}
export type ViewBucketDataHookResult = ReturnType<typeof useViewBucketData>;
export type ViewBucketDataLazyQueryHookResult = ReturnType<typeof useViewBucketDataLazyQuery>;
export type ViewBucketDataSuspenseQueryHookResult = ReturnType<
  typeof useViewBucketDataSuspenseQuery
>;
export type ViewBucketDataQueryResult = Apollo.QueryResult<ViewBucketData, ViewBucketDataVariables>;
export function mockViewBucketData({
  data,
  variables,
  errors,
}: {
  data: ViewBucketData;
  variables?: ViewBucketDataVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: ViewBucketDataDocument, variables },
    result: { data, errors },
  };
}
